import { useState } from "react";

const FORM_ENDPOINT = "https://readdy.ai/api/form/daglck1tto0ceqqnhukg";

type Status = "idle" | "success" | "error";

export default function NewsletterForm() {
  const [status, setStatus] = useState<Status>("idle");
  const [formError, setFormError] = useState("");

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    const honeypot = (data.get("phone_alt") as string) ?? "";
    if (honeypot.trim()) {
      // bot: silently mimic success
      form.reset();
      setStatus("success");
      return;
    }
    data.delete("phone_alt");

    setStatus("idle");
    setFormError("");
    try {
      const res = await fetch(FORM_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(data as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; message?: string } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const code = parsed?.code;
      const msg =
        (parsed as { meta?: { message?: string } })?.meta?.message ??
        (parsed as { message?: string })?.message;

      if (res.ok && code === "OK") {
        form.reset();
        setStatus("success");
        setFormError("");
      } else {
        setStatus("error");
        setFormError(
          msg || "订阅暂时没有成功，请稍后再试，或检查邮箱地址是否正确。"
        );
      }
    } catch {
      setStatus("error");
      setFormError("网络似乎开小差了，请稍后重试。");
    }
  }

  return (
    <form
      id="subscribe"
      data-readdy-form="daglck1tto0ceqqnhukg"
      onSubmit={handleSubmit}
      className="flex w-full max-w-md flex-col gap-3 sm:flex-row sm:items-center"
    >
      <div className="relative flex-1">
        <i className="ri-mail-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"></i>
        <input
          type="email"
          name="email"
          required
          placeholder="输入常用邮箱地址"
          aria-label="邮箱地址"
          className="h-11 w-full rounded-md border border-background-300 bg-background-50 pl-9 pr-3 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
        />
      </div>
      <button
        type="submit"
        className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
      >
        订阅内幕推送
      </button>
      {/* honeypot field - hidden via stylesheet, ignored by autofill */}
      <div className="honeypot-helper" aria-hidden="true">
        <input
          type="text"
          name="phone_alt"
          tabIndex={-1}
          autoComplete="off"
          readOnly
          placeholder="Phone"
        />
      </div>
      {status === "success" && (
        <p className="flex items-center gap-1.5 text-sm text-emerald-700 sm:w-full">
          <i className="ri-checkbox-circle-line"></i>
          订阅成功！重要内幕将第一时间送达你的邮箱。
        </p>
      )}
      {status === "error" && (
        <p className="flex items-start gap-1.5 text-sm text-red-700 sm:w-full">
          <i className="ri-alert-line"></i>
          {formError}
        </p>
      )}
    </form>
  );
}